import React from 'react';
import CMSPage from '../../components/CMSPage/CMSPage';

const HowItWorksPage = () => {
  return <CMSPage pageType="how-it-works" />;
};

export default HowItWorksPage;
